<div class="modal inmodal fade profile-modal"
     id="profile-modal-id"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     #thisModal>
  <div class="modal-dialog profile-modal__profile-dialog"
       role="document">
    <div class="modal-content profile-modal__profile-dialog__profile-content">
      <div class="modal-header profile-modal__profile-dialog__profile-content__profile-header">
        <h4 id="profileModalLabel">
          <span class="fa fa-user"
                aria-hidden="true">
          </span>
          {{'components.userProfileComponent.title' | translate}}
        </h4>
      </div>
      <div class="modal-body font-weight-bold profile-modal__profile-dialog__profile-content__profile-body">
        <label>{{'components.userProfileComponent.name' | translate}}</label>
        <label>{{userProfile != null ? userProfile.name : ''}}</label>
        <label>{{'components.userProfileComponent.userName' | translate}}</label>
        <label>{{userProfile != null ? userProfile.userName : ''}}</label>
      </div>
      <div class="modal-footer profile-modal__profile-dialog__profile-content__profile-footer">
        <button type="button"
                class="btn btn-default"
                (click)="logout()"
                data-dismiss="modal">
          <span class="fa fa-sign-out"></span>
          <span>{{'components.userProfileComponent.logout' | translate}}</span>
        </button>
        <button type="button"
                class="btn btn-default"
                (click)="onClose()"
                data-dismiss="modal">
          <span class="fa fa-times"></span>
          <span>{{'components.userProfileComponent.close' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
